function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.783 4A11.673 11.673 0 0126 14.324C26 20.772 20.773 26 14.325 26 9.848 26 5.959 23.48 4 19.783a11.635 11.635 0 005.46 1.352c6.448 0 11.675-5.227 11.675-11.677 0-1.97-.489-3.829-1.352-5.458z",
  fill: "currentColor"
})));